// extracted by mini-css-extract-plugin
module.exports = {"topicName":"TopicStatistics_topicName__3o1oe","clickCount":"TopicStatistics_clickCount__21ryo"};